import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';


class StepDateTime extends Component {
    constructor(props) {
        super(props);
        this.state = { event: this.props.event, disablenextbtn: false };
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleInputBlur = this.handleInputBlur.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.validatorListener = this.validatorListener.bind(this);
    }

    componentWillMount() {
        ValidatorForm.addValidationRule('isFutureEvent', (value) => {
            const eventdate = new Date(value);
            if (eventdate <= new Date()) {
                return false;
            }
            return true;
        });
        ValidatorForm.addValidationRule('isValidDate', (value) => {
            const eventdate = new Date(value);
            console.log("event date:", eventdate === "Invalid Date");
            if (isNaN(eventdate.getTime())) {
                return false;
            }
            return true;
        });
        ValidatorForm.addValidationRule('isValidStartDate', (value) => {
            const eventstartdate = new Date(value);
            if (eventstartdate >= new Date(this.state.event.enddatetime)) {
                return false;
            }
            return true;
        });
        ValidatorForm.addValidationRule('isValidEndDate', (value) => {
            const eventenddate = new Date(value);
            if (eventenddate <= new Date(this.state.event.startdatetime)) {
                return false;
            }
            return true;
        });
    }

    handleInputChange(event) {
        let eventState = Object.assign({}, this.state.event, { [event.target.name]: event.target.value });
        this.setState({ event: eventState });
    }

    handleInputBlur(event) {
        this.refs[event.target.name].validate(event.target.value);
    }

    validatorListener(result) {
        if(result)
            return this.props.returnfnc(this.state.event);
    }

    handleSubmit(){}

    render() {
        const { event } = this.state;
        return (
            <ValidatorForm instantValidate={false} onSubmit={this.handleSubmit}>
                <div className="row">
                    <div className="col-sm-6">
                        <TextValidator
                            ref="startdatetime"
                            name="startdatetime"
                            label="Data/ora inizio evento"
                            type="datetime-local"
                            InputLabelProps={{ shrink: true }}
                            value={event.startdatetime}
                            onBlur={this.handleInputBlur}
                            onChange={this.handleInputChange}
                            validators={['isFutureEvent', 'isValidDate', 'isValidStartDate']}
                            errorMessages={['la data non può essere antecedente a quella odierna', 'data non valida', 'la data/ora iniziale deve essere antecedente alla data/ora finale']}
                            validatorListener={this.validatorListener}
                        />
                    </div>
                    <div className="col-sm-6">
                        <TextValidator
                            ref="enddatetime"
                            name="enddatetime"
                            label="Data/ora fine evento"
                            type="datetime-local"
                            InputLabelProps={{ shrink: true }}
                            value={event.enddatetime}
                            onBlur={this.handleInputBlur}
                            onChange={this.handleInputChange}
                            validators={['isFutureEvent', 'isValidDate', 'isValidEndDate']}
                            errorMessages={['la data non può essere antecedente a quella odierna', 'data non valida', 'la data/ora finale deve essere posteriore alla data/ora iniziale']}
                            validatorListener={this.validatorListener}
                        />
                    </div>
                </div>              
            </ValidatorForm>
        );
    }
}

StepDateTime.propTypes = {
    event: PropTypes.object.isRequired,
    returnfnc: PropTypes.func.isRequired
};

export default StepDateTime;


// WEBPACK FOOTER //
// ./src/components/eventstepper/StepDateTime.js